import type { ProgressIconItemState } from 'bundles/course-frame/components/course-outline/ProgressIcon';
import type { Item } from 'bundles/learner-progress/types/Item';
import { getIsLocked } from 'bundles/learner-progress/utils/Item';

export const getItemState = (computedItem: Item): ProgressIconItemState => {
  if (computedItem.isFailed) {
    return 'failed';
  }
  if (!getIsLocked(computedItem) && (computedItem.isCompleted || computedItem.isPassed)) {
    return 'complete';
  }
  /*
    TODO: I anticipate that we will need to show locked items in the future, but for now we will not.
    For now, we will show incomplete items as locked.
  */
  // if (getIsLocked(computedItem)) {
  //   return 'locked';
  // }
  return 'incomplete';
};
